import { Module, MutationTree, GetterTree } from "vuex";
import { RootState } from "../../store.interface";
import { Order } from "@/shared/interfaces/order/Order.interface";
import { OrderStoreState, PerPackPricing } from "@/shared/interfaces/order/OrderStoreState.interface";

import api from "./api";
import transactions from "./transactions";
const defaultCurrentPricing: PerPackPricing = {
    extensionOption: {
        basic: null,
        classic: null,
        premium: null,
    },
    billboard: {
        basic: false,
        classic: false,
        premium: false,
    },
};

const initialState: OrderStoreState = {
    orders: [],
    currentOrder: null,
    manualDiscountId: null,
    currentPricing: defaultCurrentPricing
};

type PackType = "basic" | "classic" | "premium";

const modules = {
    api: api,
    transactions: transactions,
};

const state = {...initialState};

const mutations: MutationTree<OrderStoreState> = {
    currentOrder: function(state, order: Order) {
        state.currentOrder = order;
    },

    resetState: function(state) {
        Object.assign(state, initialState);
    },

    setExtensionOption: function(state, extensionOption) {
        if (!state.currentOrder) {
            return;
        }

        state.currentOrder.extensionOption = extensionOption ?? null;

        if (extensionOption && extensionOption.packType) {
            state.currentOrder.packType = extensionOption.packType;
        }
    },

    setBillboard: function(state, payload: { packType: PackType; value: boolean }) {
        state.currentPricing.billboard[payload.packType] = payload.value;
    },

    manualDiscountId: function(state, manualDiscountId: string | null) {
        state.manualDiscountId = manualDiscountId;
    },
};

const getters: GetterTree<OrderStoreState, RootState> =  {

    // Only used in `gtm/datalayer.ts`, which should be refactored.
    getCurrentOrder: state => state.currentOrder,

    visualizationKey: state => state.currentOrder?.visualizationOption?.toLowerCase() ?? "",

    visualizationOptions: state => state.currentOrder?.tariff.visualizationOptions,

    package: (state, getters) => {
        const key = getters.visualizationKey as PackType;
        const pack = getters.visualizationOptions?.[key];
        if (!pack) return null;

        return {
            ...pack,
            price: pack.price,
            totalPrice: pack.totalPrice
        };
    },

};

const orders: Module<OrderStoreState, RootState> = {
    namespaced: true,
    modules: modules,
    state: state,
    mutations: mutations,
    getters: getters,
};

export default orders;
